import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

import close_img from '../../../assets/images/close.svg'
import trash_img from '../../../assets/images/trash.svg'


import '../../../components/_modals/modalStyle.css'
import { Stream } from "@cloudflare/stream-react";
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { fetchAddLink, fetchGetVideo } from '../FolderApi';

import  Form from 'react-bootstrap/Form';
import  Modal from 'react-bootstrap/Modal';
import { Spinner } from "react-bootstrap";
import { API_URL, TENANT } from "../../../config/constants";
import SecureImage from "../../../components/_partials/SecuredImage";
import UploadButton from "../../../components/UploadButton";

export default function ContentEditModal(props)  {
    const {show, type, index, folderData} = props
    const t = useSelector(selectTranslations)

    const [videoData, setVideoData] = useState({})

    const contentData = folderData && type && index !== null ? folderData[type][index] : null

    const deleteFile = () => {
        let _content = structuredClone(folderData[type])
        _content.splice(index, 1)
        props.onClose(false, true)
        props.onFolderDataChange({
            ...folderData,
            [type] : _content
        })
    }

    const handleContentChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _content = structuredClone(folderData[type])
        _content[index][name] = value
        props.onFolderDataChange({
            ...folderData,
            [type] : _content
        })
    }

    const handleRemoveImage = () => {
        let _content = structuredClone(folderData[type])
        _content[index]['poster_image_url'] = ""
        props.onFolderDataChange({
            ...folderData,
            [type] : _content
        })
    }

    const handleUploadImage = (e) => {
        let _content = structuredClone(folderData[type])
        _content[index]['poster_image_url'] = `/${TENANT}/api${e}`
        props.onFolderDataChange({
            ...folderData,
            [type] : _content
        })
    }

    const loadVideoData = async () => {
        const response = await fetchGetVideo({video_id: contentData?.file_id})
        if(response.success){
            setVideoData(response.data)
        } else {
            console.error('error loading video');
        }
    }

    useEffect(()=>{
        if(type === 'videos')
            loadVideoData()
        console.log(props);
        
    },[show, index, type])

    return (
        <Modal
            show={show}
            onHide={()=>props.onClose(false)}
            centered
            size="lg"
        >
            <Modal.Body>
                <div className='d-flex align-items-center justify-content-between'>
                    <h2 className="text-center">{t.folder.edit} {t.folder[type]}</h2>
                    <img src={close_img} alt='' onClick={()=>props.onClose(false)} />
                </div>
                {
                    type === 'videos' && <>
                        {
                            videoData?.uid ?
                                <Stream 
                                    controls 
                                    poster={`${contentData?.poster_image_url}`}
                                    src={videoData?.uid} 
                                />
                            : <div className="video_loader">
                                <Spinner />
                            </div>
                        }
                        { !contentData?.poster_image_url ?
                            <UploadButton className='me-2 mt-3 secondary' accept='image/png, image/jpeg, image/jpg' label={t.folder.video_preview} type='material' onUpload={handleUploadImage} showProgress={true}/>
                        : null}
                        {
                           contentData?.poster_image_url ?
                            <div className='col-6'>
                                <Form.Group controlId="question_media" className='mt-2'>
                                    <Form.Label>{t.question.file}</Form.Label>
                                    <div className='question_image'>
                                        <div style={{maxWidth:'100px'}}>
                                        <SecureImage className="w-100" imageUrl={`${contentData?.poster_image_url}`} />
                                        </div>
                                        <img src={trash_img} className='pointer' onClick={handleRemoveImage} />
                                    </div>
                                    
                                </Form.Group>
                            </div> : ""
                        }
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.video_name}*</Form.Label>
                            <Form.Control type="text" value={contentData?.name} name="name" onChange={handleContentChange} />
                        </Form.Group>
                    </>
                }
                {
                    type === 'files' && <>
                        <a href={`${API_URL}/get_file?file_id=${contentData?.file_id}`} target="_blank" download>
                            <button>
                                Download
                            </button>
                        </a>
                        <Form.Check // prettier-ignore
                            type="switch"
                            id="is_downloadable"
                            name="is_downloadable"
                            className='mt-2'
                            label={t.folder.is_downloadable}
                            onChange={handleContentChange}
                            checked={contentData?.is_downloadable}
                        />
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.file_name}*</Form.Label>
                            <Form.Control type="text" value={contentData?.name} name="name" onChange={handleContentChange} />
                        </Form.Group>
                    </>
                }
                {
                    type === 'links' && <>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link_name}*</Form.Label>
                            <Form.Control type="text" value={folderData.name} name="name" onChange={handleContentChange} />
                        </Form.Group>
                        <Form.Group controlId="description" className='mt-2'>
                            <Form.Label>{t.materials.link}*</Form.Label>
                            <Form.Control type="url" value={folderData.link_url} name="link_url" placeholder={'https://...'} onChange={handleContentChange} />
                        </Form.Group>
                    </>
                }
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <a onClick={deleteFile} href="#"><strong><u>{t.folder.delete_file}</u></strong></a>
                    <button onClick={()=>props.onClose(true)}>{t.buttons.save_and_exit}</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
